import IPreferencesReducer from "models/IPreferencesReducer";
import { actionTypes } from "./actions";

const initialState: IPreferencesReducer = {
  isLoading: false,
  isLoaded: false,
  error: null,
  itemOptions: [],
  classOptions: [],
  settings: null,
  freightCosts: [],
  amStatusOptions: [],
  lineTypes: [],
  ownerTypes: [],
  transferTypes: []
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.GET_ITEM_OPTIONS_REQUEST:
      return {
        ...state,
        itemOptions: []
      };
    case actionTypes.GET_ITEM_OPTIONS_SUCCESS:
      return {
        ...state,
        itemOptions: action.payload
      };
    case actionTypes.GET_CLASS_OPTIONS_REQUEST:
      return {
        ...state,
        classOptions: []
      };
    case actionTypes.GET_CLASS_OPTIONS_SUCCESS:
      return {
        ...state,
        classOptions: action.payload
      };
    case actionTypes.GET_PREFERENCES_REQUEST:
      return {
        ...state,
        settings: null
      };
    case actionTypes.GET_PREFERENCES_SUCCESS:
      return {
        ...state,
        settings: action.payload
      };
    case actionTypes.PREFERENCES_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case actionTypes.ADD_PREFERENCES_SUCCESS:
      return {
        ...state,
        settings: action.payload,
        meta: { ...state.meta, filter: null }
      };
    case actionTypes.GET_PREFERENCES_SELECT_OPTIONS_REQUEST:
      return {
        ...state,
        freightCosts: [],
        amStatusOptions: [],
        lineTypes: [],
        ownerTypes: [],
        transferTypes: []
      };
    case actionTypes.GET_PREFERENCES_SELECT_OPTIONS_SUCCESS:
      return {
        ...state,
        freightCosts: action.payload.freightCosts,
        amStatusOptions: action.payload.amStatus,
        lineTypes: action.payload.lineTypes,
        ownerTypes: action.payload.ownerTypes,
        transferTypes: action.payload.transferTypes
      };
    default:
      return state;
  }
};
